import { Typography } from "@mui/material";

import { CompanyBranches } from "components/CompanyBranches/CompanyBranches";
import { ErrorTypography } from "components/ErrorTypography";
import { EvotruxDivider } from "components/EvotruxDivider";
import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import { useRoleContext, useSwrFetch } from "hooks";
import { PageLayout } from "layouts";

export function CompanyBranchesPage() {
  const { company, listBranchAdminRoles: getBranchAdminRoles } =
    useRoleContext();

  const url = company !== null ? `/companies/${company.id}/branches` : null;

  const {
    data: branchMembers,
    loading,
    error,
  } = useSwrFetch<BranchMembers[]>({
    url,
    errorMessage: "Failed to fetch branches",
  });

  if (company == null) {
    return null;
  }

  return (
    <PageLayout>
      <Typography variant="h3">Company Branches</Typography>
      <EvotruxDivider />
      <ErrorTypography error={error} />
      <LoadingWrappedNode loading={loading}>
        {branchMembers && (
          <CompanyBranches
            branches={branchMembers}
            viewingAsRoles={getBranchAdminRoles()}
            viewingAsCompanyAdmin={false}
          />
        )}
      </LoadingWrappedNode>
    </PageLayout>
  );
}
